var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchAbu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0312 18.3438C21.6172 18.9688 21.6172 19.9453 21.0312 20.5703C20.4062 21.1562 19.4297 21.1562 18.8047 20.5703L14.1562 15.8828C12.5547 16.9375 10.6016 17.4844 8.49219 17.2109C4.89844 16.7031 2.00781 13.7734 1.53906 10.2188C0.875 4.90625 5.36719 0.414062 10.6797 1.07812C14.2344 1.54688 17.1641 4.4375 17.6719 8.03125C17.9453 10.1406 17.3984 12.0938 16.3438 13.6562L21.0312 18.3438ZM4.58594 9.125C4.58594 11.8984 6.8125 14.125 9.58594 14.125C12.3203 14.125 14.5859 11.8984 14.5859 9.125C14.5859 6.39062 12.3203 4.125 9.58594 4.125C6.8125 4.125 4.58594 6.39062 4.58594 9.125Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAbu);
export default __webpack_public_path__ + "static/media/search_abu.4e4a6157ba2a78e22d31ff9d9b9364a8.svg";
export { ForwardRef as ReactComponent };